import type { Paths } from '@cometchat/calls-sdk-core';
import { useTranslationStore, type TranslationResource } from './state';

function get(obj: Record<string, TranslationResource>, path: string) {
  const keys = path.split('.');
  let result: unknown = obj;

  for (const key of keys) {
    if (result == null || typeof result !== 'object') {
      return '';
    }
    result = (result as Record<string, unknown>)[key];
  }

  return result as string;
}

export const useTranslation = () => {
  const { translations, currentLocale } = useTranslationStore();

  const t = (key: Paths<TranslationResource>): string => {
    return get(translations, `${currentLocale}.${key}`);
  };

  return {
    t,
    currentLocale,
    translations,
  };
};
